module.exports = __webpack_public_path__ + "static/media/brian_blessed_cutout.c96f283c.png";